import _defineProperty from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
var SkeletonTypes;
(function (SkeletonTypes) {
  SkeletonTypes["Title"] = "title";
  SkeletonTypes["Subtitle"] = "subtitle";
  SkeletonTypes["Text"] = "text";
  SkeletonTypes["Input"] = "input";
})(SkeletonTypes || (SkeletonTypes = {}));
var Skeleton = function Skeleton(_ref) {
  var type = _ref.type,
    _ref$lines = _ref.lines,
    lines = _ref$lines === void 0 ? 1 : _ref$lines;
  var linesQuantityArray = Array.from(Array(lines).keys());
  return jsxs("section", Object.assign({
    className: classNames('pp-skeleton', _defineProperty({}, "pp-skeleton--".concat(type), type)),
    "data-testid": "skeleton"
  }, {
    children: [jsx("div", Object.assign({
      className: "pp-skeleton__shimmer"
    }, {
      children: jsx("div", {
        className: "pp-skeleton__shimmer-blink"
      })
    })), linesQuantityArray.map(function (item) {
      return jsx("div", {
        className: classNames('pp-skeleton__line', _defineProperty({}, "pp-skeleton__line--".concat(type), type)),
        "data-testid": "skeleton-line"
      }, item);
    })]
  }));
};
export { Skeleton, SkeletonTypes };